import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import React, { useState, useEffect } from 'react';
import { SplitFactory } from '@splitsoftware/splitio';
import cookie from 'js-cookie';
import { Datalayer } from '@miro-site/analytics';
import { jsx as _jsx } from "react/jsx-runtime";
var anonymousIdInterval;
var STATUSES;

(function (STATUSES) {
  STATUSES["loading"] = "loading";
  STATUSES["ready"] = "READY";
  STATUSES["error"] = "ERROR";
})(STATUSES || (STATUSES = {}));

var initialValue = {
  status: STATUSES.loading,
  isLoading: true
};
var SplitIoContext = /*#__PURE__*/React.createContext([initialValue, null]);
export var SplitIoProvider = function SplitIoProvider(props) {
  var authorizationKey = props.authorizationKey,
      children = props.children,
      getAnalytics = props.getAnalytics,
      _props$triesLimit = props.triesLimit,
      triesLimit = _props$triesLimit === void 0 ? 20 : _props$triesLimit;

  var _useState = useState(initialValue),
      splitIOState = _useState[0],
      setSplitIOState = _useState[1];

  var _useState2 = useState(null),
      client = _useState2[0],
      setClient = _useState2[1];

  function isBot() {
    var userAgent = navigator.userAgent;
    var regexp = /bot|crawl|slurp|spider|mediapartners|go-http-client|apache|axios|ahc/i;
    return !!(userAgent && userAgent.match(regexp));
  }

  useEffect(function () {
    if (isBot()) {
      setSplitIOState({
        status: STATUSES.error,
        error: 'Crawler / bot detected'
      });
    } else {
      setSplitIOState({
        status: STATUSES.loading,
        error: ''
      });
      var tries = 0;
      anonymousIdInterval = window.setInterval(function () {
        if (tries >= triesLimit) {
          setSplitIOState({
            status: STATUSES.error,
            error: "Id cookie wasn't found"
          });
          clearInterval(anonymousIdInterval);
          return;
        }

        var anonymousId = cookie.get('ajs_anonymous_id');

        if (typeof anonymousId === 'string' && anonymousId.length) {
          clearInterval(anonymousIdInterval);
          initSplitIo(anonymousId.replace(/"/g, ''));
        }

        tries++;
      }, 50);
    }

    function initSplitIo(_x) {
      return _initSplitIo.apply(this, arguments);
    }

    function _initSplitIo() {
      _initSplitIo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(anonymousId) {
        var analytics, client;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getAnalytics();

              case 3:
                analytics = _context.sent;
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                setSplitIOState({
                  status: STATUSES.error,
                  error: "Analytics library wasn't initialized"
                });
                return _context.abrupt("return");

              case 10:
                // Init Split on client-side
                ;

                (function () {
                  window.split = window.split || SplitFactory({
                    core: {
                      authorizationKey: authorizationKey,
                      key: anonymousId
                    },
                    impressionListener: {
                      logImpression: function logImpression(impression) {
                        var _impression$impressio = impression.impression,
                            changeNumber = _impression$impressio.changeNumber,
                            feature = _impression$impressio.feature,
                            treatment = _impression$impressio.treatment,
                            label = _impression$impressio.label; // Make sure to connect this in GTM, otherwise events will not land on EventHub

                        analytics.sendEvent(new Datalayer('experiment_viewed', {
                          experiment_id: "".concat(feature, "#").concat(changeNumber),
                          experiment_name: feature,
                          variation_id: treatment,
                          variation_name: treatment,
                          target: label,
                          data_source: 'web-monorepo-frontend'
                        }));
                      }
                    }
                  });
                })(); // This branch runs only on the client-side


                client = window.split.client();
                _context.next = 15;
                return client.ready();

              case 15:
                _context.prev = 15;
                _context.next = 18;
                return client.ready()["catch"](function (e) {
                  throw e;
                });

              case 18:
                setSplitIOState({
                  status: STATUSES.ready,
                  error: ''
                });
                setClient(client);
                _context.next = 26;
                break;

              case 22:
                _context.prev = 22;
                _context.t1 = _context["catch"](15);
                setSplitIOState({
                  status: STATUSES.error,
                  error: "Split IO wasn't initialized"
                });
                setClient(client);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6], [15, 22]]);
      }));
      return _initSplitIo.apply(this, arguments);
    }
  }, []);
  return /*#__PURE__*/_jsx(SplitIoContext.Provider, {
    value: [_objectSpread(_objectSpread({}, splitIOState), {}, {
      isLoading: splitIOState.status == STATUSES.loading
    }), client],
    children: children
  });
};
export var useSplitIo = function useSplitIo() {
  return React.useContext(SplitIoContext);
};
export var useTreatment = function useTreatment(name, attrs) {
  var _useSplitIo = useSplitIo(),
      _useSplitIo2 = _slicedToArray(_useSplitIo, 2),
      isLoading = _useSplitIo2[0].isLoading,
      client = _useSplitIo2[1];

  return [client === null || client === void 0 ? void 0 : client.getTreatment(name, attrs), isLoading];
};